//IOS
export const IOS_APP_STORE_ID = "6450862894";
export const IOS_APP_STORE_URL =
  "https://apps.apple.com/app/" + IOS_APP_STORE_ID;

//ANDROID
export const ANDROID_PACKAGE_NAME = "com.geoflag";
export const ANDROID_PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=" + ANDROID_PACKAGE_NAME;
